import {withMeta, withSystem} from '@packages/systems/wfdl';
import {TEmptyRecord, TUnion} from '@packages/systems/wfdl-ast';

export type LinkPreloadValue = {
  tag: 'None' | 'Prefetch' | 'Prerender';
  val: Record<never, never>;
};

export const TLinkPreload = withMeta(
  {variant: 'menu'},
  withSystem(
    {label: 'Preload'},
    TUnion({
      None: TEmptyRecord,
      Prefetch: TEmptyRecord,
      Prerender: TEmptyRecord,
    })
  )
);

export type LinkTargetValue = {
  tag: 'This tab' | 'New tab';
  val: Record<never, never>;
};

export const TLinkTarget = withSystem(
  {label: 'Open in', defaultValue: {tag: 'This tab', val: {}}},
  TUnion({
    'This tab': TEmptyRecord,
    'New tab': TEmptyRecord,
  })
);
